import React, { forwardRef } from "react";
import { Paper } from "@mui/material";
import { useIsOnSmallScreen } from "@dotlegal/dotlegal-ui-components";
import { EntityType } from "../../Common.types";
import { SearchResultViewModel } from "./SearchResultList.types.ts";
import SearchResultListContent from "./SearchResultListContent.tsx";

export interface SearchResultListProps {
    items: SearchResultViewModel[];
    isLoading: boolean;
    isLink?: boolean;
    isEntitySpecificSearch: boolean;
    onItemSelected: (mention: SearchResultViewModel) => void;
    onShowMoreClick: (entityType: EntityType | undefined) => void;
    width?: number;
    noPaddingTop?: boolean;
}

const SearchResultList = forwardRef((props: SearchResultListProps, ref: any) => {
    const isSmallScreen = useIsOnSmallScreen();

    return (
        <Paper
            elevation={2}
            sx={(theme) => ({
                paddingX: 2,
                paddingBottom: 2,
                paddingTop: props.noPaddingTop ? 0 : 2,
                width: props.width ?? (isSmallScreen ? 400 : 700),
                "& .MuiButtonBase-root.MuiMenuItem-root.Mui-selected": {
                    backgroundColor: theme.palette.primary.light,
                },
                fontSize: theme.typography.pxToRem(14),
                zIndex: 2000,
            })}
        >
            <SearchResultListContent
                items={props.items}
                isLoading={props.isLoading}
                isLink={props.isLink}
                isEntitySpecificSearch={props.isEntitySpecificSearch}
                onItemSelected={props.onItemSelected}
                onShowMoreClick={props.onShowMoreClick}
                ref={ref}
            />
        </Paper>
    );
});

SearchResultList.displayName = "SearchResultList";

export default SearchResultList;
